import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../store/authSlice';
import { MapPin, User, LogOut, Settings } from 'lucide-react';

const Navbar = () => {
  const { isAuthenticated, user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  return (
    <nav className="bg-gradient-to-r from-purple-900 via-blue-900 to-indigo-900 backdrop-blur-2xl shadow-2xl border-b border-purple-500/30 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-24">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-4 group">
              <div className="relative animate-float">
                <MapPin className="h-12 w-12 text-cyan-400 group-hover:text-pink-400 transition-all duration-500 animate-glow" />
                <div className="absolute -top-2 -right-2 w-4 h-4 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full animate-pulse"></div>
                <div className="absolute -bottom-1 -left-1 w-3 h-3 bg-gradient-to-r from-green-400 to-blue-500 rounded-full animate-ping"></div>
              </div>
              <div className="flex flex-col">
                <span className="text-3xl font-black text-white animate-pulse-slow">TripForge</span>
                <span className="text-xs text-cyan-300 font-medium tracking-widest">PREMIUM TRAVEL</span>
              </div>
            </Link>
          </div>

          <div className="flex items-center space-x-2">
            <Link
              to="/features"
              className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-purple-600/20 to-pink-600/20 hover:from-purple-600/40 hover:to-pink-600/40 border border-purple-400/30 hover:border-purple-400/60"
            >
              ✨ Features
            </Link>
            <Link
              to="/about"
              className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-blue-600/20 to-cyan-600/20 hover:from-blue-600/40 hover:to-cyan-600/40 border border-blue-400/30 hover:border-blue-400/60"
            >
              👥 About
            </Link>
            <Link
              to="/contact"
              className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-orange-600/20 to-red-600/20 hover:from-orange-600/40 hover:to-red-600/40 border border-orange-400/30 hover:border-orange-400/60"
            >
              📞 Contact
            </Link>
            {isAuthenticated ? (
              <>
                <Link
                  to="/dashboard"
                  className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-green-600/20 to-emerald-600/20 hover:from-green-600/40 hover:to-emerald-600/40 border border-green-400/30 hover:border-green-400/60"
                >
                  🏠 Dashboard
                </Link>
                <Link
                  to="/favorites"
                  className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-red-600/20 to-pink-600/20 hover:from-red-600/40 hover:to-pink-600/40 border border-red-400/30 hover:border-red-400/60"
                >
                  ❤️ Favorites
                </Link>
                {user?.role === 'admin' && (
                  <Link
                    to="/admin"
                    className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-indigo-600/20 to-purple-600/20 hover:from-indigo-600/40 hover:to-purple-600/40 border border-indigo-400/30 hover:border-indigo-400/60 flex items-center space-x-2"
                  >
                    <Settings className="h-4 w-4" />
                    <span>👑 Admin</span>
                  </Link>
                )}
                <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-md px-4 py-2 rounded-xl border border-white/20">
                  <User className="h-5 w-5 text-cyan-300" />
                  <span className="text-sm text-white font-medium">{user?.name}</span>
                </div>
                <button
                  onClick={handleLogout}
                  className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-gray-600/20 to-red-600/20 hover:from-gray-600/40 hover:to-red-600/40 border border-gray-400/30 hover:border-red-400/60 flex items-center space-x-2"
                >
                  <LogOut className="h-4 w-4" />
                  <span>🚪 Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="btn-ghost text-sm px-6 py-3 text-white bg-gradient-to-r from-cyan-600/20 to-blue-600/20 hover:from-cyan-600/40 hover:to-blue-600/40 border border-cyan-400/30 hover:border-cyan-400/60"
                >
                  🔑 Login
                </Link>
                <Link
                  to="/register"
                  className="btn-primary text-sm px-8 py-3 text-white bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 shadow-xl hover:shadow-pink-500/50"
                >
                  🚀 Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;